import React from 'react';
import styles from './Modal.module.scss';
import { useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import { axiosBackend } from '../../../../axios/Axios.js';
// import "./Modal.css"
import { getToken } from "../../../../services/auth";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import dayjs, { Dayjs } from 'dayjs';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useSnackbar } from 'notistack'

export default function Modal({reloadContratcts, formData, setFormData, isOpen, onClose, startDateObj }) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const MODAL_URL = "/contracts";

  const [loading, setLoading] = useState(false);

  const config = {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getToken()}`
    },
  }

  const handleSubmit = () => {
    setLoading(true);
      axiosBackend.post(MODAL_URL, { ...formData, start: formData.start.unix(), end: formData.end.unix() }, config).then( (response) => {
        reloadContratcts();
        if (formData.title === "Adicionar"){
          enqueueSnackbar('Contrato adicionado com sucesso!', { 
            variant: 'success'
          });
        } else {
          enqueueSnackbar('Contrato editado com sucesso!', { 
            variant: 'success'
          });
        }
        setLoading(false);
        onClose();
      }).catch ((error) => {
      if (formData.title === "Adicionar"){
        enqueueSnackbar('Falha ao adicionar contrato!', { 
          variant: 'error'
        });
      } else {
        enqueueSnackbar('Falha ao editar contrato!', { 
          variant: 'error'
        });
      }
      setLoading(false);
      onClose();
    }); 
  };

  return (
    <div className={`overlay ${isOpen ? 'open' : ''}`}>
      <div className={styles.draw_box}>
        <div className={styles.main_column}>
          <h1 className={styles.main_title}>{formData.title} contrato</h1>
          <div className={styles.main_row}>
            <div className={styles.main_row_item}>
              <label className={styles.field_title}>Nome do contrato</label>
              <input
                required
                className={styles.input_box_1}
                placeholder="Escreva o nome do contrato"tittle
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
              <small className={styles.helper_text}>ex: FinOps ABC</small>
            </div>
            <div className={styles.main_row_item}>
              <label className={styles.field_title}>Keyword</label>
              <input
                className={styles.input_box_1}
                placeholder="Escreva a chave do contrato"
                value={formData.key}
                onChange={(e) => setFormData({ ...formData, key: e.target.value })}
              />
              <small className={styles.helper_text}>ex: VNNCLD</small>
            </div>
          </div>
          <div className={styles.main_row}>
          <div className={styles.main_row_item}>
            <label className={styles.field_title}>Data inicial</label>
            <div className={styles.time_div}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
              <DatePicker
              
              required={true}
              minDate={startDateObj}
              value={formData.start}
              format="DD/MM/YYYY"
              onChange={(newValue) =>  setFormData({ ...formData, start: newValue })}
              />
            </LocalizationProvider>
            </div>
          </div>
          <div className={styles.main_row_item}>
            <label className={styles.field_title}>Data final</label>
            <div className={styles.time_div}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
              <DatePicker
              required={true}
              minDate={formData.start}
              value={formData.end}
              format="DD/MM/YYYY"
              onChange={(newValue) =>  setFormData({ ...formData, end: newValue })}
              />
            </LocalizationProvider>
            </div>
          </div>
          </div>
          <div className={styles.main_row}>
            <div className={styles.main_row_item}>
              <label className={styles.field_title}>Tipo de contrato</label>
              <div className={styles.checkbox_modal}>
                <label className={styles.container}>
                  <input type="checkbox" checked={formData.sust} name="sust" value="Sustentação" onChange={(e) => setFormData({ ...formData, sust: e.target.checked})}/>
                  <span className={styles.checkmark}>
                    <div className={styles.checkIconDiv}>
                      <div className={styles.checkIcon} />
                    </div>
                  </span>
                  <div className={styles.containerText}>Sustentação</div>
                </label>
                <label className={styles.container}>
                  <input type="checkbox" checked={formData.proj} name="proj" value="Projeto" onChange={(e) => setFormData({ ...formData, proj: e.target.checked})}/>
                  <span className={styles.checkmark}>
                    <div className={styles.checkIconDiv}>
                      <div className={styles.checkIcon} />
                    </div>
                  </span>
                  <div className={styles.containerText}>Projeto</div>
                </label>
              </div>
            </div>
            <div className={styles.main_row_item}>
              <label className={styles.field_title}>Horas contratadas</label>
              <div className={styles.time_div}>
              <TextField
                style = {{width: "50%", borderTopRightRadius: 0 +"!important", borderBottomRightRadius: 0+"!important"}}
                id="horas-contratadas"
                type="number"
                className={styles.numberField}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{ inputProps: { min: 0 }, className: styles.numberField}}
                value={formData.hours}
                onChange={(e) => {setFormData({ ...formData, hours: e.target.value })}
                }
              />
              <Select
                style = {{width: "49%"}}
                labelId="bymonth"
                id="bymonth"
                value={formData.bymonth}
                className={styles.numberFieldFreq}
                onChange={(e) =>  setFormData({ ...formData, bymonth: e.target.value })}
              >
                <MenuItem value={true}>horas por mês</MenuItem>
                <MenuItem value={false}>horas totais</MenuItem>
              </Select>
              </div>
            </div>
          </div>
          {/* bymonth?? */}
          <div className={styles.main_row}>
            <button disabled={loading} className={styles.cancel_button} onClick={() => {
                onClose();
              }}>
              Cancelar
            </button>
            <button
              disabled={(formData.hours == 0) || (!formData.sust && !formData.proj) || !formData.name || !formData.key ||loading ? true : false}
              className={(loading ? styles.send_button_loading : styles.send_button)}
              onClick={() => {
                handleSubmit();
              }}
            >
              {formData.button}
            </button>
          </div>
          
        </div>
      </div>
    </div>
  );
}